export class MaxPayoutPercentageExceededError extends Error {
    constructor() {
        super('Payout percentage cannot exceed 100%');
    }
}
